
<template>
    <div class="col-md-9">
        <h1 class="pages__title">menus</h1>
        <div class="pages__table">
            <div class="pages__top">
                <div class="title-page">
                    <a href="/admin/panel/menus" class="color_primary">Menus&nbsp;/&nbsp;</a>
                    <span>{{ menuDetails.name }}</span>
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <draggable v-model="menuItems" @end="onDragEnd">
                <li
                    class="pages__line pages__line_move"
                    v-for="item in menuItems"
                    :key="item.id"
                >
                    <button type="button" class="move">Move Item</button>
                    <div class="title-page">
                        {{ item.title }}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a class="edit" @click="openEditModal(item)">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a  class="delete" @click="openDeleteModal(item)">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
                </draggable>
            </ul>
        </div>
        <div class="add-link mt-3">
            <a href="javascript:void(0)" @click="showCustomModal('create', null)">+ Add  New</a>
        </div>
        <ActionModal
            v-if="currentItem"
            :modal-id="getCustomModalId('delete',currentItem.id)"
            @confirm="deleteMenuItem(currentItem.id)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this item?</p>
                    </div>
                </div>
            </template>
        </ActionModal>

        <ModalMenuItem
            v-if="currentItem"
            :modal-id="getCustomModalId('edit',currentItem.id)"
            :reject-text="`Back`"
            :confirm-text="`Save`"
            :current-item="currentItem"
            :pages="pages"
            @confirm="updateItem"

        />
        <ModalMenuItem
            :modal-id="getCustomModalId('create', null)"
            :reject-text="`Back`"
            :confirm-text="`Save`"
            :pages="pages"
            @confirm="updateItem"
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminPanelService from "../../../services/AdminPanelService";
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import ModalMenuItem from "../../Common/ModalMenuItem.vue";
import draggable from "vuedraggable";

export default defineComponent({
    name: "MenusItems",
    components: {draggable, ModalMenuItem, ActionModal},
    mixins: [ModalHandler],
    props: {
        menuId: {
            type: Number
        }
    },
    data() {
        return {
            currentItem: null,
            menuDetails: null,
            pages: [],
            menuItems: []
        }
    },
    methods: {
        onDragEnd() {
            this.$showLoadingMessage()
            const newOrder = this.menuItems.map((item) => item.id);
            this.updateMenuItemsOrder(newOrder);
        },
        async updateMenuItemsOrder(newOrder) {
            try {
                await AdminPanelService.updateMenuItemsOrder(newOrder)
                this.$showSuccessMessage('The order was changed!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The order was not changed')
            }
        },
        async updateItem(result) {
            try {
                 this.$showSuccessMessage('The Menu item was saved!')
                const response = await AdminPanelService.updateMenuItems(this.menuDetails.id, result)
                if (response){
                    await this.fetchMenuInnerItems()
                }
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The Menu item was not saved!')
            }
        },
        openEditModal(item) {
            this.currentItem = item
            this.$nextTick(()=> {
                this.showCustomModal('edit', item.id)
            })
        },
        openDeleteModal(item) {
            this.currentItem = item
            this.$nextTick(()=> {
                this.showCustomModal('delete', item.id)
            })
        },
        async fetchMenuInnerItems() {
            try {
               const { data: response }  = await AdminPanelService.fetchMenuInnerItems(this.menuId)
                this.menuDetails = response
                this.menuItems = response.menu_items.sort((a, b) => a.order - b.order)
            } catch (e) {
                console.error(e)
            }
        },
        async fetchListOfPages() {
            try {
                const { data: response }  = await AdminPanelService.fetchListOfPages()
                this.pages = response
            } catch (e) {
                console.error(e)
            }
        },
        async deleteMenuItem(menuId) {
            try {
                await AdminPanelService.deleteMenuItem(menuId)
                this.$showSuccessMessage('The Menu was deleted!')
                await this.fetchMenuInnerItems()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The Menu was not deleted. Please try again')
            }
        }

    },
    mounted() {
        this.fetchMenuInnerItems()
        this.fetchListOfPages()
    }
})
</script>

<style scoped>

</style>
